<template>
    <v-row style="height:100%;width:100%;" align="center" justify="center">
        <v-col align="center">
            <v-card style="max-width:500px;background: transparent;text-align: left;" flat dark>
                <v-card-title>404</v-card-title>
                <v-card-subtitle>Sidan hittades ej</v-card-subtitle>
                <v-card-text>
                    {{$browserDetect.meta.ua}}
                </v-card-text>

                <v-img contain :src="require('../assets/conf_travolta.gif')"></v-img>
            </v-card>
        </v-col>

    </v-row>

</template>

<script>
    export default {
        name: "NotFound.vue"
    }
</script>

<style scoped>

</style>
